import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { SimpleField } from '../../abstracts/simple-field';

@Component({
  selector: 'fb-color-field',
  templateUrl: './color-field.component.html',
  styleUrls: ['./color-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorFieldComponent extends SimpleField<string> {
  patterns: { [key: string]: { pattern: RegExp } } = { C: { pattern: new RegExp('[a-fA-F0-9]') } };

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Self()
    public override ngControl: NgControl,
  ) {
    super(changeDetectorRef, ngControl);
  }
}
